import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/icons/white-cart-fast-order.avif")